export default "__VITE_ASSET__Df18$cZy__"